import { render, staticRenderFns } from "./FormContentSectionComponent.vue?vue&type=template&id=bc58da46&scoped=true"
import script from "./FormContentSectionComponent.vue?vue&type=script&lang=js"
export * from "./FormContentSectionComponent.vue?vue&type=script&lang=js"
import style0 from "./FormContentSectionComponent.vue?vue&type=style&index=0&id=bc58da46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc58da46",
  null
  
)

export default component.exports